//  Copyright (c) 2022 Generated Systems Technologies, Inc. All rights reserved.

import React from 'react';
import { Button, FormGroup, FormControl, ControlLabel, Radio } from 'react-bootstrap';
import './ViewEula.css';
import ErrorDialog from './ErrorDialog';
import PageHeader from '../components/PageHeader';
import { API } from 'aws-amplify';
import config from '../config';
import EulaText from '../components/EulaText';

class ViewEula extends React.Component {
  constructor(props) {
    super(props);

    this.handleClick_CloseButton = this.handleClick_CloseButton.bind(this);
  }

  async componentDidMount() {}

  async handleClick_CloseButton() {
    window.close();
/*    
    try {
      this.props.history.push('/login');
    } catch (e) {
      this.refs.errorDialog.displayError('Error', e.message);
    }
*/    
  }
  
  render() {
    return (
      <div className='Eula'>
        <PageHeader title='End-User License Agreement' info='Please read the following license agreement carefully.' />
        <div style={{ padding: '30px' }} className='widget'>
          <form name='eulaForm' autocomplete='off'>
            <EulaText/>
{/*
            <Button
              style={{ marginTop: '20px' }}
              bsSize='large'
              onClick={() => {
                this.handleClick_CloseButton();
              }}
              alt='...'
            >
              Close
            </Button>
*/}            
          </form>
        </div>
        <ErrorDialog ref='errorDialog' />
      </div>
    );
  }
}

export default ViewEula;
